export const IS_AVAILABLE_CURBSIDE_SERVICE_MODE = true;
